import { Loader2 } from 'lucide-react';
import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthenticateToBackend } from '@/queries/useAuthenticate';

import { AuthContext, ORIGINAL_PATH_STORAGE_KEY, shouldKeepOriginalPath } from './AuthContext';

const ProtectedRoute = () => {
  const { user, isAuthenticating: isAuthenticatingToGoogle } = useContext(AuthContext);
  const { data: backendUser, isFetching: isAuthenticatingToBackend } = useAuthenticateToBackend({
    enabled: !!user && !isAuthenticatingToGoogle
  });

  const isAuthenticating = isAuthenticatingToGoogle || isAuthenticatingToBackend;

  const { pathname } = useLocation();

  if (isAuthenticating || !backendUser) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  if (!user) {
    if (shouldKeepOriginalPath(pathname)) {
      sessionStorage.setItem(ORIGINAL_PATH_STORAGE_KEY, pathname);
    }
    return <Navigate to="/sign-in" replace />;
  }

  return <Outlet />;
};

export { ProtectedRoute };
